export const tableStyles = {
  container: {
    position: 'relative',
    w: '100%',
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      height: '8px'
    },
    '&::-webkit-scrollbar-track': {
      bg: 'gray.800'
    },
    '&::-webkit-scrollbar-thumb': {
      bg: 'gray.600',
      borderRadius: 'full',
      '&:hover': {
        bg: 'gray.500'
      }
    }
  },
  tableContainer: {
    minW: '100%',
    bg: 'gray.900'
  },
  table: {
    tableLayout: 'fixed',
    w: 'max-content',
    minW: '100%',
    '& td, & th': {
      minW: '120px',
      maxW: '300px',
      p: '3',
      whiteSpace: 'normal',
      wordBreak: 'break-word'
    }
  },
  headerCell: {
    py: 3,
    px: 4,
    fontSize: 'xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    borderBottom: '2px',
    borderColor: 'gray.200',
    backgroundColor: 'gray.700',
    color: 'gray.100',
    position: 'sticky',
    top: 0,
    zIndex: 1
  },
  row: {
    transition: 'all 0.2s',
    _hover: {
      backgroundColor: 'blue.800'
    }
  },
  cell: {
    py: 3,
    px: 4,
    fontSize: 'sm',
    borderColor: 'whiteAlpha.100',
    color: 'gray.100',
    _groupHover: {
      color: 'white'
    }
  }
}
